import { type SxProps, type Theme } from "@mui/material/styles";

import { type BreadcrumbKind } from "ui/breadcrumbs/breadcrumbs.types";

type UnlinkedKind = Exclude<BreadcrumbKind, "link">;

/** The two unlinked crumbs. The link is `ui/link`'s own `small` / `primary`. */
export const BREADCRUMB_TEXT_COLOR: Record<UnlinkedKind, (theme: Theme) => string> = {
  current: (theme) => theme.palette.text.primary,
  text: (theme) => theme.palette.text.disabled,
};

export const BREADCRUMB_TEXT_SX: Record<UnlinkedKind, SxProps<Theme>> = {
  current: (theme) => ({ color: BREADCRUMB_TEXT_COLOR.current(theme) }),
  text: (theme) => ({ color: BREADCRUMB_TEXT_COLOR.text(theme) }),
};
